<template>
  <div class="subscription-page">
    <div class="row pb-5">
      <div class="col-12 col-lg-8 mx-auto mt-n4">
        <div class="bg-white shadow-sm p-5 position-relative">
          <LoaderContent
            v-if="!graphql_loaded"
            :welcomeMessage="false"
            :alignSpinnerTop="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderContent from "ninenine-white-label/src/components/Loader/LoaderContent.vue";

export default {
  name: "AcceptHunting",

  data() {
    return {
      graphql_loaded: false,
      isSaving: false,
    };
  },

  head() {
    return this.$head({
      title: "",
    });
  },

  components: {
    LoaderContent,
  },

  mounted() {
    const acceptHunting = this.$store
      .dispatch("user/acceptHunting", {
        token: this.$route.params.token,
      })
      .then((hunting) => {
        let id = hunting.data.acceptHunting.id;
        let forceChangePassword =
          hunting.data.acceptHunting.forceChangePassword;
        let name = hunting.data.acceptHunting.name;

        this.$store.dispatch("user/auth", {
          user: {
            id: id,
            name: name,
          },
          keepLogged: true,
        });
        setTimeout(() => {
          this.$store
            .dispatch(
              "graphql_queries/query",
              `
              user( id: "${id}" ){
                profile{
                  cpf,
                }
              },
            `
            )
            .then((results) => {
              let document = results.user.profile.cpf;
              if (document == null) {
                this.$router.push(
                  `/InsertCpf?name=${name}&code=${this.$route.params.token}`
                );
              } else {
                this.$router.push(`/meu-perfil`);
              }
            });
        }, 500);
      });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
/deep/ .loader-content {
  top: 240px;
  background: none;
}
</style>
